/**
 * 任务中心路由配置
 * @description 任务相关路由
 */
import type { RouteRecordRaw } from 'vue-router'

const taskRoutes: RouteRecordRaw[] = [
  {
    path: '/tasks',
    name: 'TaskList',
    component: () => import('@/views/TaskList.vue'),
    meta: {
      title: '任务中心',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 3,
    },
  },
  {
    path: '/tasks/:id',
    name: 'TaskDetail',
    // 已迁移至 views/TaskDetail.vue 解决架构不合理问题
    component: () => import('@/views/TaskDetail.vue'),
    meta: {
      title: '任务详情',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 3,
    },
  },
  {
    path: '/designers',
    name: 'DesignerList',
    component: () => import('@/views/DesignerList.vue'),
    meta: {
      title: '找设计师',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 4,
    },
  },
  {
    path: '/designers/:id',
    name: 'DesignerDetail',
    component: () => import('@/views/DesignerDetail.vue'),
    meta: {
      title: '设计师详情',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 4,
    },
  },
  {
    path: '/providers/:id',
    name: 'ProviderDetail',
    component: () => import('@/views/ProviderDetail.vue'),
    meta: {
      title: '服务商详情',
      requiresAuth: false,
      cache: false,
      breadcrumb: true,
      order: 4,
    },
  },
]

export default taskRoutes
